/**
 * La trousse portée, couchée à l'horizontale en haut à droite de chaque tableau de bord (élève, prof, parent, curieux) :
 * elle flotte au-dessus de son ombre, sa fermeture éclair s'entrouvre de temps en temps, et la
 * toucher ouvre la collection (`/trousses`). Rien pour une session anonyme.
 */
import { Link } from '@tanstack/react-router';
import { useAuth } from '@/lib/auth';
import { trousseImage, useMyTrousse } from '@/lib/trousses';
import './trousse.css';
import './dashboard-trousse.css';

const DEFAULT_COVER = 'trousses/01.webp';

export function DashboardTrousse({ className }: { className?: string }) {
  const { user } = useAuth();
  const userId = user && !user.is_anonymous ? user.id : null;
  const { data } = useMyTrousse(userId);
  if (!userId) return null;
  const equipped = data?.equipped ?? null;
  const cover = trousseImage(equipped?.image_path ?? DEFAULT_COVER);
  const name = equipped?.name ?? 'Graphite';
  return (
    <Link
      to="/trousses"
      data-testid="dashboard-trousse"
      aria-label={`Ma trousse « ${name} » : voir ma collection`}
      title="Mes trousses"
      className={`jr-dtr${className ? ` ${className}` : ''}`}
    >
      <span className="jr-dtr-shadow" aria-hidden />
      <span className="jr-dtr-body" aria-hidden>
        <span className="jr-dtr-turn">
          <i className="jr-dtr-cover" style={{ backgroundImage: `url(${cover})` }} />
          <span className="jr-tr-zip">
            <i className="jr-tr-rail" />
            <i className="jr-tr-gap" />
            <i className="jr-tr-pull" />
          </span>
        </span>
      </span>
    </Link>
  );
}
